import { render, staticRenderFns } from "./WizardSteps.vue?vue&type=template&id=4e45a4c8&scoped=true"
import script from "./WizardSteps.vue?vue&type=script&lang=js"
export * from "./WizardSteps.vue?vue&type=script&lang=js"
import style0 from "./WizardSteps.vue?vue&type=style&index=0&id=4e45a4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45a4c8",
  null
  
)

export default component.exports